<template>
    <el-dialog title="提现申请" :visible.sync="dialogShow" @close="closeDialog" @open="openDialog">

        <el-form :model="form" :rules="rules" ref="form">

            <el-form-item label="提现金额" :label-width="formLabelWidth" prop="amount">
                <el-col :span="12">
                    <el-input v-model="form.amount" autocomplete="off" placeholder="请输入提现金额"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="银行名称" :label-width="formLabelWidth" prop="bankName">
                <el-col :span="12">
                    <el-input v-model="form.bankName" autocomplete="off" placeholder="请输入提现提现银行"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="支行名称" :label-width="formLabelWidth" prop="bankName">
                <el-col :span="12">
                    <el-input v-model="form.branchName" autocomplete="off" placeholder="请输入提现提现银行"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="姓名" :label-width="formLabelWidth" prop="certName">
                <el-col :span="12">
                    <el-input v-model="form.certName" autocomplete="off" placeholder="请输入姓名"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="银行卡号" :label-width="formLabelWidth" prop="bankCardNo">
                <el-col :span="12">
                    <el-input v-model="form.bankCardNo" autocomplete="off" placeholder="请输入银行卡号"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="支付密码" :label-width="formLabelWidth" prop="payPassword">
                <el-col :span="12">
                    <el-input type="password" v-model="form.payPassword" autocomplete="off"
                              placeholder="请输入支付密码"></el-input>
                </el-col>
            </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="saveMerchant">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import md5 from 'js-md5';
    export default {
        name: "SystemEdit",
        props: {
            show: Boolean,
            formData: Object,
            action: String,

        },

        created() {
            // this.$axios.get("/agent/selectListForOption", {params: {}}).then(res => {
            //     this.agentList = res.data;
            // })
        },
        data() {
            return {
                dialogShow: this.show,
                form: {
                    certName: "",
                    bankCardNo: "",
                    amount: "",
                    bankName: "",
                    payPassword: ""
                },
                agentList: [],
                formLabelWidth: '120px',
                rules: {
                    amount: [
                        {required: true, message: '请输入提现金额', trigger: 'blur'}
                    ],
                    bankCardNo: [
                        {required: true, message: '请输入正确的银行卡号', trigger: 'blur'},
                        {min: 15, max: 20, message: '请输入6到20个数字', trigger: 'blur'},
                    ],
                    bankName: [
                        {required: true, message: '请选择银行卡', trigger: 'blur'}
                    ],
                    certName: [
                        {required: true, message: '请输入姓名', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {

            agentNameChange() {

            },

            openDialog() {
                if (this.formData != null) {

                } else {
                    this.$refs['form'].resetFields(); //关闭的时候重置表单
                }
            },
            closeDialog() {
                this.dialogShow = false;
                this.$refs['form'].resetFields(); //关闭的时候重置表单
                this.$emit('update:show', false);
            },

            saveMerchant() {

                if (this.action === "addWithdraw") {
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            let obj = Object.assign({}, this.form);
                            obj.payPassword = md5(obj.payPassword);
                            this.axios.post("/withdraw/applyForAgent", obj).then(res => {
                                if (res.code === 200) {

                                    this.$notify({
                                        title: '添加成功',
                                        message: res.msg,
                                        type: 'success'
                                    });

                                    this.$bus.$emit('refresh'); //通知刷新

                                    this.closeDialog();
                                } else {

                                    this.$notify.error({
                                        title: '添加失败',
                                        message: res.msg,
                                    });
                                }
                            })
                        } else {
                            return false;
                        }
                    });
                }

                if (this.action === "editMerchant") {
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            this.axios.post("/merchant/updateMerchant", this.form).then(res => {
                                if (res.code === 200) {

                                    this.$notify({
                                        title: '添加成功',
                                        message: res.msg,
                                        type: 'success'
                                    });

                                    this.$bus.$emit('refresh'); //通知刷新

                                    this.closeDialog();
                                } else {

                                    this.$notify.error({
                                        title: '添加失败',
                                        message: res.msg,
                                    });
                                }
                            })
                        } else {
                            return false;
                        }
                    });
                }

            }
        },
        watch: {
            show(newVal) {
                this.dialogShow = newVal;
            }
        },
    }
</script>

<style scoped>

</style>